import { DateLimits } from "../context/filters/filters.types";

export const getDateLimits = (
  date: Date = new Date(),
  range: number,
): DateLimits => {
  const today = new Date();
  const initialDate = new Date(
    new Date(today).setMonth(today.getMonth() - (range - 1)),
  );

  initialDate.setDate(1);

  return { startDate: initialDate, endDate: date };
};
